import Glide from '@glidejs/glide'

export default function Slider() {
    const el = document.querySelector('.glide');

    if (!el) return;

    const glide = new Glide(el, {
        type: 'carousel',
        focusAt: 'center',
        perView: 3,
        breakpoints: {
            1100: {
                perView: 1,
                peek: 150
            },
            800: {
                perView: 1,
                peek: 70
            },
            400: {
                perView: 1,
                peek: 30
            }
        },
        gap: -10,
        animationTimingFunc: 'ease',
        // autoplay: 5000,
    });

    glide.mount();
}
